import type { DefaultPatientEventResponse } from "@/api";

import { HeartCoreCharts } from "@/features/patient/heartcore-charts/heartcore-charts";

/**
 * The charts shown in the worklist's Trends sheet — the same HeartCore report
 * the patient profile's HeartCore tab plots, events timeline included.
 *
 * `scopedScroll` points the charts' zoom bar at the sheet's own scroll area
 * instead of the page: it otherwise positions itself `fixed` against the
 * window, which inside a sheet means floating over content it doesn't belong to.
 */
export function TrendsCharts({
  patientId,
  events,
  canAfib,
}: {
  patientId: number;
  events: DefaultPatientEventResponse[];
  /**
   * Forwarded because the charts hide the AFib plot when it is absent — the
   * panel is billed as the same report the profile's HeartCore tab shows, so
   * omitting it would drop that chart here for a user who holds the bit.
   */
  canAfib: boolean;
}) {
  return (
    <HeartCoreCharts
      patientId={patientId}
      variant="heartcore"
      events={events}
      canAfib={canAfib}
      scopedScroll
    />
  );
}
